// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { useSharedSession } from '../../shared/auth';
import styles from './ProvisioningHeader.module.css';

/**
 * Top bar. Deliberately sparse — this is an internal tool, and the visible
 * "Internal" marker is the point: it should be obvious from a screenshot that
 * this is not a customer surface.
 */
export default function ProvisioningHeader() {
  const { initials } = useSharedSession();

  return (
    <header className={styles.header}>
      <span className={styles.product}>Helios Provisioning</span>
      <span className={styles.env}>Qcells internal</span>
      <span className={styles.spacer} />
      {initials && (
        <span className={styles.initials} aria-hidden="true">
          {initials}
        </span>
      )}
    </header>
  );
}
